import { render, staticRenderFns } from "./TemplateEmailList.vue?vue&type=template&id=c63931bc&"
import script from "./TemplateEmailList.vue?vue&type=script&lang=js&"
export * from "./TemplateEmailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports